import BetSlipOdd from '@core/models/base/BetSlipOdd';
import {
    CreateBetBuilderOddDto,
    CreateBetBuilderOddV2Dto,
} from '../types/dtos/CreateBetBuilderOddDto';
import {
    doneOddStatuses,
    OddStatus,
} from '@core/models/shared/odds/OddStatus';
import { PayoutService } from '@core/services/betSlip/PayoutService';
import OfferEvent from '@core/models/offer/OfferEvent';

export function transformCreateBetBuilderOdd(
    dto: CreateBetBuilderOddDto,
    event?: OfferEvent,
    fallbackMarketName?: string,
): BetSlipOdd {
    const oddStatus = dto.os as OddStatus;
    const market = event?.getMarkets().find((m) => {
        // Bet Group IDs and odd IDs are not _fully unique_ on specifier markets, and we don't have
        // the market uuid, so we're using an existing hack to combine odd ID with special bet value
        // to handle specifier market edge cases.
        return m.odds.some((odd) => odd.uniqueId === `${dto.oi} ${dto.osbv}`);
    });
    const isFinished = doneOddStatuses[oddStatus];
    const isShownOnOffer = oddStatus === OddStatus.active || oddStatus === OddStatus.block;

    return {
        id: dto.oi,
        value: dto.ov,
        name: 'Bet Builder Odd',
        isLocked: oddStatus !== OddStatus.active,
        marketId: dto.bgi,
        marketName: market?.name ?? fallbackMarketName ?? '',
        marketUuid: dto.muuid,
        description: '',
        specialBetValue: dto.osbv,
        isFinished,
        isShownOnOffer,
        isBonusable: PayoutService.getInstance().isOddValidForSuperBonus(dto.tags),
        isInPromotion: false, // TODO: Double-check
        tags: dto.tags,
        uuid: dto.uuid,
        isSuperbet: true,
    };
}

export function transformCreateBetBuilderOddV2(
    dto: CreateBetBuilderOddV2Dto,
): BetSlipOdd {
    const isFinished = doneOddStatuses[dto.status as OddStatus];

    const isShownOnOffer = dto.status === OddStatus.active || dto.status === OddStatus.block;

    return {
        id: dto.outcomeId,
        value: dto.price,
        name: dto.name,
        isLocked: dto.status !== OddStatus.active,
        marketId: dto.marketId,
        marketName: dto.marketName,
        marketUuid: dto.marketUuid ?? '',
        description: dto.info,
        specialBetValue: dto.specialBetValue,
        isFinished,
        isShownOnOffer,
        isBonusable: PayoutService.getInstance().isOddValidForSuperBonus(dto.marketTags),
        isInPromotion: false, // TODO: Double-check
        tags: dto.marketTags,
        uuid: dto.uuid,
        isSuperbet: true,
    };
}
